import { vars } from 'src/core/themes';

import { PosIconProps, SvgWrapper } from '../SvgWrapper';

export const ParkingIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper
      {...props}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 36C32.2801 36 35.7758 32.6389 35.9902 28.4121L36 28V12C36 7.71993 32.6389 4.22423 28.4121 4.00977L28 4H12C7.58172 4 4 7.58172 4 12V28C4 32.4183 7.58172 36 12 36H28ZM33 28C33 30.7614 30.7614 33 28 33H12C9.23858 33 7 30.7614 7 28V12C7 9.23858 9.23858 7 12 7H28C30.7614 7 33 9.23858 33 12V28Z"
        fill={vars.color.textPrimaryV2}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 17C26 20.3137 23.3137 23 20 23H17V27.5C17 28.3284 16.3284 29 15.5 29C14.6716 29 14 28.3284 14 27.5V13.5C14 12.1193 15.1193 11 16.5 11H20C23.3137 11 26 13.6863 26 17ZM20 14C21.6569 14 23 15.3431 23 17C23 18.6569 21.6569 20 20 20H17V14H20Z"
        fill={vars.color.textPrimaryV2}
      />
    </SvgWrapper>
  );
};
